import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createEvalAppeal = (payload) => post(baseURL + url.EVAL_APPEAL, payload);
export const getEvalAppealDetails = (id) => get(`${baseURL + url.EVAL_APPEAL}/${id}`);
export const updateEvalAppeal = (id, payload) => put(`${baseURL + url.EVAL_APPEAL}/${id}`, payload);
export const deleteEvalAppeal = (id) => remove(`${baseURL + url.EVAL_APPEAL}/${id}`);
